<template>
  <b-modal :visible="show"
           lazy
           centered
           :hide-footer="isSetStateOpinion"
           :title="$t('Add Review')"
           @hidden="close"
           @show="setInitStars"
           :cancel-title="$t('Cancel')"
           @ok="submitOpinion"
           :ok-title="$t('Add Review')"
           ok-variant="ls"
           size="md">
    <div class="text-center">
      <h2 class="m--margin-bottom-20">{{$t('Rating customer service')}}</h2>
      <div class="text-nowrap">
        <span v-for="x in 5"
              :key="x"
              class="fa fa-star star"
              :class="{['font-ls']: x <= stars, 'cursor-pointer': !isSetStateOpinion}"
              @click="setStars(x)"></span>
      </div>
      <p v-if="missingStarError" class="small m--margin-top-10 text-danger">
          {{$t('Check at least one star')}}
      </p>
    </div>
    <div class="m--margin-top-40 text-center">
      <h2 class="m--margin-bottom-20">{{$t('Justify rating')}}</h2>
      <div class="row">
        <div class="col-lg-10 offset-lg-1">
          <b-form-textarea
                  v-if="!isSetStateOpinion"
                  v-model="opinion"
                  :placeholder="$t('Rating text')"
                  rows="3"
                  max-rows="6"
          ></b-form-textarea>
          <p v-else class="jumbotron padding-20">
            {{ stateOpinion.opinion }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="!isSetStateOpinion && opinionPremiumActivityEnabled" class="m--margin-top-20 text-center">
      <h6>{{$t('Give point for rating')}}</h6>
    </div>
  </b-modal>
</template>

<script>
  import {mapActions, mapState} from 'vuex'

  export default {
    name: "OperationOpinionModal",
    data() {
      return {
        stars: 0,
        opinion: '',
        missingStarError: false
      }
    },
    methods: {
      ...mapActions([
        'closeOpinionModal',
        'fetchOperations'
      ]),
      close() {
        this.closeOpinionModal();
        this.stars = 0;
        this.opinion = "";
        this.missingStarError = false;
      },
      setStars(x) {
        if (!this.isSetStateOpinion)  {
          this.stars = x
        }
      },
      setInitStars() {
        if (!this.isSetStateOpinion)  {
          this.stars = 0
        } else {
          this.stars = parseInt(this.stateOpinion.stars)
        }
      },
      submitOpinion(e) {
        if (this.stars === 0) {
          this.missingStarError = true;
          e.preventDefault();
          return;
        }

        this.missingStarError = false;

        this.$http.post('operations/opinions', {
          operationId: this.operationId,
          stars: this.stars,
          opinion: this.opinion
        })
          .then((r) => {
            if (r.data.success) {
              this.fetchOperations();
            } else {
              e.preventDefault();
            }
          });
      }
    },
    computed: {
      ...mapState({
        show: state => state.settings.opinionModal.show,
        stateOpinion: state => state.settings.opinionModal.opinion,
        operationId: state => state.settings.opinionModal.operationId,
        opinionPremiumActivityEnabled: state => state.settings.opinionPremiumActivity === '1',
      }),
      isSetStateOpinion() {
        return this.stateOpinion !== null;
      }
    }
  }
</script>

<style scoped>
  .star {
    font-size: 5rem;
    color: #c3c3c3;
  }

  @media screen and (max-width: 400px) {
    .star {
      font-size: 15vw;
    }
  }
  .cursor-pointer {
    cursor: pointer;
  }

  .padding-20 {
    padding: 20px;
  }
</style>
